import { mangaList } from "@/mocks/manga";
import { getCategory } from "@/utils/manga";
import MangaGrid from "@/components/feature/MangaGrid";
import SectionTitle from "@/components/feature/SectionTitle";

export default function NewWorks() {
  const news = mangaList
    .filter((m) => m.isNew)
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 6);
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20" id="new">
      <SectionTitle
        eyebrow="新鲜出炉"
        title="新作推荐"
        subtitle="每周精选人气新作，第一时间追上最新上线的精彩漫画。"
        to="/new"
        moreLabel="更多新作"
      />
      <div className="mb-5 flex flex-wrap gap-2">
        {[...new Set(mangaList.filter((m) => m.isNew).map((m) => getCategory(m.category).name))].map((name) => (
          <span
            key={name}
            className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900"
          >
            {name}
          </span>
        ))}
      </div>
      <MangaGrid items={news} cols={6} />
    </section>
  );
}